import { upperFirst } from 'lodash'
import React from 'react'
import { useTranslation } from 'react-i18next'

import KpiMap from 'src/commons/graphs/KpiMap'
import { IFeature } from 'src/commons/types'

interface IProps {
  data: {
    features: IFeature[]
    type: string
  }
  origin?: boolean
  title?: string
}

function TripsPerZone(props: IProps) {
  const { t } = useTranslation()
  const tooltipLegend = props.origin
    ? upperFirst(t('kpi.TripsPerOriginZone.tooltip'))
    : upperFirst(t('kpi.TripsPerDestinationZone.tooltip'))
  const legend = props.origin ? t('kpi.TripsPerOriginZone.mapLegend') : t('kpi.TripsPerDestinationZone.mapLegend')
  return <KpiMap title={props.title} data={props.data} legend={legend} tooltipLegend={tooltipLegend} />
}

export default TripsPerZone
